module.exports = __webpack_public_path__ + "img/bplus-home-sv.140bd215.png";